import script from "./AsideNewsList.vue?vue&type=script&setup=true&lang=js"
export * from "./AsideNewsList.vue?vue&type=script&setup=true&lang=js"

import "./AsideNewsList.vue?vue&type=style&index=0&id=7bbc180e&lang=scss"

const __exports__ = script;

export default __exports__